import MarkdownText from "components/atoms/markdown";

export default function AboutTextSection({ aboutText }) {
  if (!aboutText) return null;
  return (
    <section className="py-10">
      <div className="max-w-6xl mx-auto px-2">
        <MarkdownText prose className="prose-h2:font-bold">{aboutText}</MarkdownText>
      </div>
    </section>
  );
}
